import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./es/common.json";
import gl from "./gl/common.json";

const STORAGE_KEY = "salnes_lang";

const detectDefault = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "es" || stored === "gl") return stored;
  const nav = (navigator.language || "es").toLowerCase();
  if (nav.startsWith("gl")) return "gl";
  // Default UI language is ES per client contract (Fase 1). GL remains a
  // first-class option via the language selector.
  return "es";
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: es },
      gl: { common: gl },
    },
    lng: detectDefault(),
    fallbackLng: "es",
    defaultNS: "common",
    ns: ["common"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

export const setLanguage = (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
  i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
};

document.documentElement.lang = i18n.language;

export default i18n;
